import React from 'react';
import { Divider as MuiDivider, makeStyles } from '@material-ui/core';

import styles from './Divider.styles';

export interface DividerProps {
  color?: string;
  className?: string;
}

const useStyles = makeStyles(styles, { name: 'Divider' });

export default function Divider({ color, className }: DividerProps) {
  const classes = useStyles({ color });
  return (
    <MuiDivider classes={classes} className={className} />
  );
}
